import styled from 'styled-components';

import { StepCircleProps } from './types';

import CheckMarkSvg from 'assets/img/check-mark.svg';

import { color } from 'theme/selectors';

export const CircleContainer = styled.div`
    position: relative;
`;

export const Circle = styled.div<StepCircleProps>`
    font-weight: 700;
    width: 32px;
    height: 32px;
    border-radius: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid ${color('border-default')};

    ${({ isCurrentStep, theme }) =>
        isCurrentStep && {
            backgroundColor: theme['primary-disabled'],
            borderColor: theme['primary-default'],
        }}

    ${({ isFinished, theme }) =>
        isFinished && {
            borderColor: theme['primary-default'],
            backgroundColor: theme['primary-default'],
        }}
`;

export const CheckMark = styled(CheckMarkSvg)``;

export const LabelContainer = styled.div`
    position: absolute;
    margin-top: 8px;
    width: 50px;
    right: -9px;
`;
